<template>
  <div class="info-bar mb-3">
    <template v-if="item">
      <img :src="item.logo | imagePath('merchantLogo', 'thumbnail')"
           :alt="item.name + '\'s logo'"
      >
      <h3 class="title">{{ item.name }}</h3>
    </template>
  </div>
</template>

<script>
import imagePath from '@/filters/image-path';

export default {
  props: { item: Object },
  filters: {
    imagePath,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin/modal/modal-history-status';

.info-bar {
  @include container;

  img {
    @include image;
  }

  .title {
    @include title;
  }
}
</style>
